import type { Attributes } from '@scayle/storefront-nuxt'
import { SHOE_SIZES_ATTRIBUTES_KEYS, type SizeSystem } from '~/constants'

export type ExtendedSizeSystem = SizeSystem | 'sizeOther'

export const useItemSize = (attr: Attributes, sizeTab: ExtendedSizeSystem) => {
  const isShoesSize = sizeTab !== 'sizeOther'
  const activeSizeVersion = isShoesSize
    ? SHOE_SIZES_ATTRIBUTES_KEYS[sizeTab]
    : 'size'

  return attr[activeSizeVersion]?.values
}
